import { createProductUpdatesRepository } from '../../repositories';

export const ProductUpdatesService = {
  fetchUpdates: async () => {
    const repository = createProductUpdatesRepository();
    const response = await repository.fetchUpdates();
    return response;
  },

  createUpdate: async (updateData) => {
    const repository = createProductUpdatesRepository();
    const response = await repository.createUpdate(updateData);
    return response;
  },

  updateUpdate: async (id, updateData) => {
    const repository = createProductUpdatesRepository();
    const response = await repository.updateUpdate(id, updateData);
    return response;
  },

  deleteUpdate: async (id) => {
    const repository = createProductUpdatesRepository();
    const response = await repository.deleteUpdate(id);
    return response;
  }
}; 